export function getTemplate(translate: (s: string) => string, isEwd?: boolean) {
    return `<div class="graphView" style="display:none">
        <div class="graphView__placeholder"><span class="placeholder__text">${translate("Rendering graph...")}</span></div>
        <div class="graphContainer">
            <div class="graphView__wrapper"></div>
            <div class="graphRenderContainer ${isEwd ? "ewd" : ""}"></div>
        </div>
    </div>`;
}
